module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_aokei-a475bd2a81d371c4f855a66ff97c5546.jpg";